export default function Stepper({ steps = [], activeIndex = 0, onChange }) {
    return (
        <div className="flex items-center justify-center gap-0 py-4">
            {steps.map((step, i) => {
                const isActive = i === activeIndex;
                const isCompleted = i < activeIndex;
                const isLast = i === steps.length - 1;

                return (
                    <div key={step.id} className="flex items-center">
                        <button
                            type="button"
                            onClick={() => onChange(step.id)}
                            className="flex items-center gap-2 group"
                        >
                            <span className={`
                                w-7 h-7 rounded-full flex items-center justify-center text-xs font-semibold
                                transition-all duration-200 shrink-0
                                ${isActive
                                    ? 'bg-gray-900 text-white'
                                    : isCompleted
                                        ? 'bg-gray-900 text-white'
                                        : 'bg-white text-gray-400 border-2 border-gray-200 group-hover:border-gray-400'
                                }
                            `}>
                                {isCompleted ? (
                                    <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                    </svg>
                                ) : (
                                    i + 1
                                )}
                            </span>
                            <span className={`
                                text-sm font-medium whitespace-nowrap transition-colors
                                ${isActive ? 'text-gray-900' : isCompleted ? 'text-gray-700' : 'text-gray-400'}
                            `}>
                                {step.label}
                            </span>
                        </button>
                        {!isLast && (
                            <div className={`
                                w-12 h-px mx-3
                                ${i < activeIndex ? 'bg-gray-900' : 'bg-gray-200'}
                            `} />
                        )}
                    </div>
                );
            })}
        </div>
    );
}
